module.exports = __webpack_public_path__ + "img/1502771083.24a0eb36.jpg";